import { render, staticRenderFns } from "./WidgetRules.vue?vue&type=template&id=5fca3c93"
import script from "./WidgetRules.vue?vue&type=script&lang=js"
export * from "./WidgetRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports